import { render } from "./AddDriverModal.vue?vue&type=template&id=65acaea4&scoped=true"
import script from "./AddDriverModal.vue?vue&type=script&lang=js"
export * from "./AddDriverModal.vue?vue&type=script&lang=js"

import "./AddDriverModal.vue?vue&type=style&index=0&id=65acaea4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65acaea4"]])

export default __exports__